export const filterState = [
  {
    id: 0,
    name: "Todos"
  },
  {
    id: 1,
    name: "A iniciar"
  },
  {
    id: 2,
    name: "Em execução"
  },
  {
    id: 3,
    name: "Concluído"
  }
];
